import * as React from 'react';
import { cn } from '../lib/utils';

export type FieldProps = React.HTMLAttributes<HTMLDivElement>;

const Field = React.forwardRef<HTMLDivElement, FieldProps>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('space-y-2', className)} {...props} />
));
Field.displayName = 'Field';

export interface FieldLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  variant?: 'default' | 'plain';
}

const FieldLabel = React.forwardRef<HTMLLabelElement, FieldLabelProps>(
  ({ className, style, variant = 'default', ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        variant === 'default' && 'type-label uppercase text-muted-foreground',
        className,
      )}
      style={style}
      {...props}
    />
  ),
);
FieldLabel.displayName = 'FieldLabel';

export type FieldMessageProps = React.HTMLAttributes<HTMLParagraphElement>;

const FieldMessage = React.forwardRef<HTMLParagraphElement, FieldMessageProps>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cn('text-sm text-destructive', className)} {...props} />
  ),
);
FieldMessage.displayName = 'FieldMessage';

export type FieldHintProps = React.HTMLAttributes<HTMLParagraphElement>;

const FieldHint = React.forwardRef<HTMLParagraphElement, FieldHintProps>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cn('text-sm text-muted-foreground', className)} {...props} />
  ),
);
FieldHint.displayName = 'FieldHint';

export { Field, FieldLabel, FieldMessage, FieldHint };
